










































































































import Component from "vue-class-component";
import Vue from "vue";
import { parseToNumber, valueOrEmpty } from "@/utils/number";
import { isTextCharacteristic } from "@/utils/characteristic-data-type";
import CharacteristicTitle from "@/components/reports/partials/show/characteristic-title.vue";

@Component({
  components: { CharacteristicTitle },
  props: {
    characteristics: Array,
    totalColumns: Number,
    expandTextCells: {
      type: Boolean,
      default: false
    },
    showHeaderRow: {
      type: Boolean,
      default: true
    }
  }
})
export default class CharacteristicsTable extends Vue {
  private currentRow: number = -1;
  private currentCol: number = -1;

  private onMouseOver(row: number, col: number) {
    this.currentRow = row;
    this.currentCol = col;
  }

  private onMouseLeave() {
    this.currentRow = -1;
    this.currentCol = -1;
  }

  private showValueOrEmpty(val: any) {
    return valueOrEmpty(val);
  }

  private showError(value: any, min: any, max: any) {
    const minValue = parseToNumber(min);
    const maxValue = parseToNumber(max);

    if (value && (minValue || maxValue)) {
      const num = parseToNumber(value);

      if (num && minValue && !maxValue) {
        return num < minValue;
      } else if (num && !minValue && maxValue) {
        return num > maxValue;
      } else if (num && minValue && maxValue) {
        return num < minValue || num > maxValue;
      }
    } else if (value && valueOrEmpty(value) === "nok") {
      return true;
    }

    return false;
  }

  private isTextCharacteristic(dataType) {
    return isTextCharacteristic(dataType);
  }
}
